import memoize from 'lodash-es/memoize';
import {
    USER_STROLLERS_ADD_REVIEW,
    USER_STROLLERS_DELETE,
    USER_STROLLERS_MY_REVIEW,
} from 'mk/autogenerated/translations/UserStrollerItem.b23e86e8244d6820b699dd17e6bf2c05'
import { ScoreNumber, ScoreNumberType } from 'mk2/apps/strollers/components/ScoreNumber';
import { StrollerEntity, StrollerUserReviewEntity } from 'mk2/apps/strollers/schemas';
import { strollersAddReviewUrl, strollersDetailUrl, strollersReviewsUrl } from 'mk2/apps/strollers/urls';
import Img from 'mk2/components/Img';
import Link from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './UserStrollerItem.mscss';

interface OwnProps {
    stroller: StrollerEntity;
    review?: StrollerUserReviewEntity;
    username: string;
    canMaintain: boolean;
    canWriteReview: boolean;
    onRemoveMyStroller(strollerId: number, username: string);
}

type Props = OwnProps;

export default class UserStrollerItem extends React.Component<Props> {
    private handleOnRemoveMyStroller = memoize(() => () => {
        const { stroller, username, onRemoveMyStroller } = this.props;
        onRemoveMyStroller(stroller.id, username);
    });

    public render() {
        const { stroller, review, canMaintain, canWriteReview } = this.props;
        const showDeleteButton = canMaintain;
        const showReviewInfo = !canMaintain;
        return (
            <div className={styles.UserStrollerItem}>
                <div className={styles.UserStrollerItem__image}>
                    <a href={url(strollersDetailUrl, { slug: stroller.slug })}>
                        <Img
                            className={styles.UserStrollerItem__image__img}
                            src={stroller.photos?.[0]?.photo.url100x100}
                            width={36}
                            height={36}
                        />
                    </a>
                </div>
                <div className={styles.UserStrollerItem__meta}>
                    <a href={url(strollersDetailUrl, { slug: stroller.slug })}>
                        <div className={styles.UserStrollerItem__meta__name}>{stroller.name}</div>
                    </a>
                    {showReviewInfo && review && (
                        <Link to={url(strollersReviewsUrl, { slug: review.stroller.slug }, {}, `review-${review.id}`)}>
                            <span className={styles.UserStrollerItem__meta__reviewAvailable}>
                                {USER_STROLLERS_MY_REVIEW}:{' '}
                            </span>
                            <ScoreNumber
                                className={styles.UserStrollerItem__meta__scoreNumber}
                                score={parseFloat(review.score.toFixed(1))}
                                type={ScoreNumberType.Small}
                            />
                        </Link>
                    )}
                    {showReviewInfo && !review && canWriteReview && (
                        <a href={url(strollersAddReviewUrl, { slug: stroller.slug })}>
                            <div className={styles.UserStrollerItem__meta__reviewMissing}>
                                {USER_STROLLERS_ADD_REVIEW}
                            </div>
                        </a>
                    )}
                    {showDeleteButton && (
                        <span
                            className={styles.UserStrollerItem__meta__delete}
                            onClick={this.handleOnRemoveMyStroller()}
                        >
                            {USER_STROLLERS_DELETE}
                        </span>
                    )}
                </div>
            </div>
        );
    }
}
